module.exports = "<div class=\"promo-content\">\r\n    <p><strong>Sorry, this information is not available to free users. Please sign in or register for JustisOne Professional.</strong></p>\r\n    <p>{{> register-button}}</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/free-promo-content-unavailable.html
// module id = 437
// module chunks = 1